<!--
 * @Descripttion: 
 * @version: 
 * @Author: Qf
 * @Date: 2022-09-19 09:41:07
 * @LastEditTime: 2022-09-19 15:25:55
 * @LastEditors: Qf
-->
<template>
  <div class="foucs">
    <swiper :options="swiperOption"
            ref="mySwiper">
      <!-- slides -->
      <swiper-slide v-for="(item,index) in banners"
                    :key="index">
        <a :href="item.link"
           class="swiper-item"
           :style="'background:url('+item.code+') center center no-repeat;background-size:1920px 430px'"></a>
      </swiper-slide>
      <!-- Optional controls -->
      <div class="swiper-pagination banner-pagination"
           slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  props: ["banners"],
  data () {
    return {
      swiperOption: {
        pagination: {
          el: ".banner-pagination",
        },
        autoplay: true,
      }
    };
  },
  mounted () {
    console.log(this.banners);
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted () {
    this.swiper.slideTo(3, 1000, false);
  }
};
</script>

<style scoped>
.main {
  padding: 50px 0;
}
.foucs {
  /* display: block;
  background: url(../../../assets/image/banner_01.png) no-repeat;
  background-size: 1920px 430px;
  width: 100%;
  height: 430px; */
}
.swiper-item {
  display: block;
  background-size: 1920px 430px;
  width: 100%;
  height: 430px;
}
.swiper-pagination {
  bottom: 70px !important;
}
</style>
